import React from 'react';
import withIcon from '../utilities/withIcon';

const IconMoreAndroid = () => {
  return (
    <g>
      <path d="M8 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
    </g>
  );
};

export default withIcon(IconMoreAndroid);
